import clsx from "clsx";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline";
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  ...props
}) => {
  const baseClasses = "cursor-pointer rounded-md px-4 py-2 transition";
  const colorClasses =
    variant === "primary"
      ? "bg-lifeguards-blue text-lifeguards-white hover:bg-lifeguards-light-blue"
      : variant === "secondary"
      ? "bg-lifeguards-white text-lifeguards-blue hover:bg-blue-100/50"
      : variant === "outline"
      ? "bg-lifeguards-white text-lifeguards-blue hover:bg-blue-100/50 border border-lifeguards-blue"
      : "bg-lifeguards-white text-lifeguards-blue hover:bg-lifeguards-light-blue";
  const disabledClasses = "disabled:cursor-not-allowed disabled:opacity-60";
  const { className, ...rest } = props;

  return (
    <button
      className={clsx(
        //  Base styles
        baseClasses,

        // Colors
        colorClasses,

        //  Disabled state
        disabledClasses,

        //  Custom class overrides (passed via props)
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};
